gsap.registerPlugin(ScrollTrigger);
document.addEventListener("DOMContentLoaded", () => {

    let mm = gsap.matchMedia();

    const magGrid = document.querySelector('.mag-grid');
    mm.add("(min-width: 1024px)", () => {
        gsap.timeline({
            scrollTrigger: {
                trigger: magGrid,
                start: "top bottom",
                end: "center center",
                scrub: 2,

            }
        })
            .fromTo('.mag-grid__left', {
                x: -100,
            }, {
                duration: 0.5,
                x: 0,
            })
            .fromTo('.mag-grid__ttl', {
                y: -100,
            }, {
                duration: 0.5,
                y: 0,
            }, "<")
            .fromTo('.mag-grid__center', {
                y: 100,
            }, {
                duration: 0.5,
                y: 0,
            }, "<")
            .fromTo('.mag-grid__right', {
                x: 100,
            }, {
                duration: 0.5,
                x: 0,
            }, "<")
    });


});